export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const DEBUG_MESSAGE_PREFIX = '[DEBUG]:';
export const ROOT_ROUTE = '/';
export const DEFAULT_GRID_CONTAINER_SPACING = 4;
export const DEFAULT_PAPER_ELEVATION = 2;

export const CHANNEL = 'GRANT_API';

declare global {
    interface Window {
        __RUNTIME_CONFIG__: {
            API_URL: string;
            COOKIE_NAME: string;
            RECOVERY_PASSWORD_LINK: string;
            LOGIN_LINK: string;
            SIGNUP_LINK: string;
            MOJE_GWO_LINK: string;
            PORTAL_GWO_LINK: string;
            GRANT_DOMAIN: string;
        };
    }
}

export const {
    API_URL: API_URL,
    COOKIE_NAME: COOKIE_NAME,
    RECOVERY_PASSWORD_LINK: RECOVERY_PASSWORD_LINK,
    LOGIN_LINK: LOGIN_LINK,
    SIGNUP_LINK: SIGNUP_LINK,
    MOJE_GWO_LINK: MOJE_GWO_LINK,
    PORTAL_GWO_LINK: PORTAL_GWO_LINK,
    GRANT_DOMAIN: GRANT_DOMAIN,
} = window.__RUNTIME_CONFIG__;

export const LOGOUT_LINK = `${MOJE_GWO_LINK}/uzytkownik/wyloguj?redirect=${window.location.origin}/login`;
export const ENLARGE_WEB = 'ENLARGE_WEB';
